// extracted by mini-css-extract-plugin
export default {"App":"reset-password_App__+koyr","Card":"reset-password_Card__wssQD"};